export const STATIC_TERMS_PATH = '/terms-of-service.md';

export async function fetchStaticTermsMarkdown() {
  const response = await fetch(STATIC_TERMS_PATH, { cache: 'no-store' });
  if (!response.ok) throw new Error('Could not load Terms of Service.');
  return response.text();
}

export function isPlaceholderLegalBody(body) {
  const text = String(body || '').trim();
  if (!text) return true;
  return text.includes('Draft placeholder') || text.includes('Full terms continue in the admin editor');
}
